import { render, staticRenderFns } from "./PurchaseOfferRejectDialog.vue?vue&type=template&id=b22bfc1a&scoped=true&"
import script from "./PurchaseOfferRejectDialog.vue?vue&type=script&lang=js&"
export * from "./PurchaseOfferRejectDialog.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOfferRejectDialog.vue?vue&type=style&index=0&id=b22bfc1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22bfc1a",
  null
  
)

export default component.exports